import { withStyles } from '@mui/styles';

import ClientMessagesForm from './ClientMessagesForm';
import { muiStyles } from './styles';

export default withStyles(muiStyles)(ClientMessagesForm);